import { createContext, useMemo, useContext, useState, useCallback, useEffect } from "react";

const ShellUIState = createContext(undefined);

const getStoredCollapsed = () => {
    try {
        return localStorage.getItem('avaco_sidebar_collapsed') === '1';
    } catch {
        return false;
    }
};

export const ShellUIProvider = ({ children }) => {
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const [isDesktopCollapsed, setIsDesktopCollapsed] = useState(getStoredCollapsed);

    const openMobile = useCallback(() => setIsMobileOpen(true), []);
    const closeMobile = useCallback(() => setIsMobileOpen(false), []);
    const toggleDesktopCollapsed = useCallback(() => {
        setIsDesktopCollapsed((prev) => {
            const next = !prev;
            try {
                localStorage.setItem('avaco_sidebar_collapsed', next ? '1' : '0');
            } catch {
                // ignore storage failures
            }
            return next;
        });
    }, []);

    useEffect(() => {
        if (!isMobileOpen) return;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileOpen]);

    const values = useMemo(() => (
        { isMobileOpen, openMobile, closeMobile, isDesktopCollapsed, toggleDesktopCollapsed }
    ),
    [isMobileOpen, openMobile, closeMobile, isDesktopCollapsed, toggleDesktopCollapsed]);

    return <ShellUIState.Provider value={values}>{children}</ShellUIState.Provider>
}

export const useShellUI = () => {
    const context = useContext(ShellUIState);
    if (context === undefined) {
        throw new Error(
            "useShellUI must be used within a ShellUIProvider"
        );
    }
    return context;
};
